
import { Component, OnInit, Injector, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { BasePage } from '../../services/base-page';
import { TitlebarComponent } from '../titlebar/titlebar.component';


/**
 * 404 錯誤頁面組件
 *
 * 用於顯示 404 (找不到頁面) 錯誤的頁面組件。
 * 當用戶訪問不存在的頁面或路由時，系統會自動導向到此頁面，
 * 提供友好的錯誤提示。此組件繼承自 BasePage，保持與應用
 * 其他頁面一致的基本功能。
 */
@Component({
  standalone: true,
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  styleUrls: [],
  imports: [FormsModule, MatCardModule, TitlebarComponent],
})
export class Error404Component extends BasePage {
  /**
   * 程式ID，用於識別此頁面
   * 在系統中標識為 'error404'
   */
  override _programId = 'error404';//###

  /**
   * 建構函數
   * @param inject 注入器，用於獲取服務和依賴
   */
  constructor() {
    const injector = inject(Injector);

    super(injector);

  }


}
